import { IMAGE_WEBP_QUALITY } from './imagePresets';

/**
 * Build image processor overrides for a FormLayout image field.
 *
 * @param {{ extensions?: string[], content?: { max_width?: number, max_height?: number, max_bytes?: number } }} field
 */
export function getFormImagePresetOverrides(field) {
    const rawExt = (field.extensions?.[0] || 'jpeg').toLowerCase().replace(/^\./, '');
    const overrides = {
        maxWidth: Number(field.content?.max_width) || 1920,
        maxHeight: Number(field.content?.max_height) || 1920,
        preservePng: false,
        preserveAlpha: false,
    };

    if (field.content?.max_bytes)
        overrides.maxBytes = Number(field.content.max_bytes);

    if (rawExt === 'png' || rawExt === 'gif') {
        overrides.preservePng = true;
        overrides.preserveAlpha = true;
    } else if (rawExt === 'webp') {
        overrides.outputFormat = 'webp';
        overrides.webpQuality = IMAGE_WEBP_QUALITY;
    }

    return overrides;
}
